module.exports = __webpack_public_path__ + "static/media/left-arrow.6c9efe0c.svg";